module.exports = __webpack_public_path__ + "static/media/logo.ce7dd5fd.png";